import { useMemo, useState } from 'react'
import { Plus } from 'lucide-react'
import { useTimes, useTime } from '../hooks/useTime'
import { Time, TimeFilters, TimeFormData } from '../tipos/time'
import { FiltrosTime } from '../componentes/FiltrosTime'
import { ListaTime } from '../componentes/ListaTime'
import { FormularioTime } from '../componentes/FormularioTime'

function convertTimeToFormData(time: Time | null): TimeFormData | undefined {
  if (!time) return undefined
  return { id: time.id, descricao: time.descricao, externo: time.externo }
}

export default function Times() {
  const [filters, setFilters] = useState<TimeFilters>({ search: '' })
  const [showForm, setShowForm] = useState(false)
  const [editingTime, setEditingTime] = useState<Time | null>(null)
  const [editingTimeId, setEditingTimeId] = useState<number | null>(null)

  const { data: times = [], isLoading, refetch } = useTimes(filters)
  const { data: timeCompleto, isLoading: isLoadingTime } = useTime(editingTimeId ?? undefined)

  const timeParaEdicao = useMemo(() => {
    if (timeCompleto) return timeCompleto
    return convertTimeToFormData(editingTime)
  }, [timeCompleto, editingTime])

  const handleSearch = (newFilters: TimeFilters) => setFilters(newFilters)
  const handleCreate = () => {
    setEditingTime(null)
    setEditingTimeId(null)
    setShowForm(true)
  }
  const handleEdit = (time: Time) => {
    setEditingTime(time)
    setEditingTimeId(time.id)
    setShowForm(true)
  }
  const handleCloseForm = () => {
    setShowForm(false)
    setEditingTime(null)
    setEditingTimeId(null)
  }

  return (
    <>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Times</h1>
          <p className="mt-1 text-sm text-gray-600">Gerencie os times da equipe</p>
        </div>
        <div className="mt-4 sm:mt-0">
          <button
            type="button"
            onClick={handleCreate}
            className="px-4 py-2 text-white bg-brand-500 rounded-lg hover:bg-brand-600 transition-all duration-200 shadow-theme-sm font-medium"
          >
            <Plus className="w-4 h-4 mr-2 inline" />
            Novo Time
          </button>
        </div>
      </div>

      <FiltrosTime onSearch={handleSearch} />
      <ListaTime times={times} isLoading={isLoading} onRefresh={refetch} onEditTime={handleEdit} />
      <FormularioTime isOpen={showForm} onClose={handleCloseForm} time={timeParaEdicao} isEditing={!!editingTimeId} />

      {isLoadingTime && editingTimeId && (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm">
          <div className="bg-white px-6 py-4 rounded-lg shadow-lg flex items-center gap-3">
            <div className="loading-spinner w-6 h-6 border-2 border-brand-500 border-t-transparent rounded-full animate-spin" />
            <span className="text-sm text-gray-700">Carregando dados do time...</span>
          </div>
        </div>
      )}
    </>
  )
}
